module.exports = __webpack_public_path__ + "img/icbcEasy.170bd28c.png";